export const numberStartsWithPlus = (value: string) =>
  value.startsWith('+') && !Number.isNaN(Number.parseInt(value.substring(1), 10));
